export const $ = <T extends HTMLElement = HTMLElement>(id: string): T => {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing element #${id}`);
  return el as T;
};

export const $in = (id: string) => $<HTMLInputElement>(id);

/** mark one button pressed in a segmented group by its data-* value */
export function setPressed(groupId: string, isOn: (b: HTMLButtonElement) => boolean) {
  $(groupId).querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(isOn(b))));
}

export const css = (n: string) => getComputedStyle(document.documentElement).getPropertyValue(n).trim();
